import { MdErrorOutline, MdArrowForward } from "react-icons/md";
import GstInput from "./GstInput";
import styles from "../../pages/GSTReconciliation/GSTReconciliation.module.scss";

interface GSTAccountFormStepProps {
  gstin: string;
  gstUsername: string;
  apiEnabled: boolean;
  formError: string;
  showAuthBanner: boolean;
  authBanner: { title: string; body: string };
  auth4037Count?: number;
  otpLimited?: boolean;
  onGstinChange: (value: string) => void;
  onUsernameChange: (value: string) => void;
  onApiEnabledChange: (value: boolean) => void;
  onEnableApiAccess: () => void;
  onShowAuthHelp?: () => void;
}

export default function GSTAccountFormStep({
  gstin,
  gstUsername,
  apiEnabled,
  formError,
  showAuthBanner,
  authBanner,
  auth4037Count = 0,
  otpLimited = false,
  onGstinChange,
  onUsernameChange,
  onApiEnabledChange,
  onEnableApiAccess,
  onShowAuthHelp,
}: GSTAccountFormStepProps) {
  return (
    <>
      <div className={styles.connectFormGroup}>
        <GstInput
          id="cg-gstin"
          label="GSTIN"
          placeholder="22AAAAA9999A1Z5"
          value={gstin}
          maxLength={15}
          hasError={showAuthBanner}
          onChange={(e) => onGstinChange(e.target.value.toUpperCase())}
        />

        <GstInput
          id="cg-user"
          label="Username"
          placeholder="user1234@27gst"
          value={gstUsername}
          hasError={showAuthBanner}
          onChange={(e) => onUsernameChange(e.target.value)}
        />
      </div>

      <div className={styles.connectCheckGroup}>
        <div className={styles.checkboxRow}>
          <input
            type="checkbox"
            id="api-enabled"
            checked={apiEnabled}
            onChange={(e) => onApiEnabledChange(e.target.checked)}
          />
          <label htmlFor="api-enabled">I have enabled API access for this GSTIN.</label>
        </div>
        <span className={styles.enableLink} onClick={onEnableApiAccess}>
          How do I enable API access?
        </span>
      </div>

      {otpLimited ? (
        <div className={styles.connectAuthBanner}>
          <div className={styles.authBannerTop}>
            <MdErrorOutline />
            <span className={styles.authBannerTitle}>
              Too many incorrect attempts. Try again in 15 minutes.
            </span>
          </div>
        </div>
      ) : showAuthBanner ? (
        <div className={styles.connectAuthBanner}>
          <div className={styles.authBannerTop}>
            <MdErrorOutline />
            <span className={styles.authBannerTitle}>{authBanner.title}</span>
          </div>
          <div className={styles.authBannerBody}>
            <p className={styles.authBannerText}>{authBanner.body}</p>
            {auth4037Count === 1 && (
              <span className={styles.authBannerLink} onClick={onShowAuthHelp}>
                Here's how to enable it <MdArrowForward />
              </span>
            )}
          </div>
        </div>
      ) : formError ? (
        <div className={styles.connectAuthBanner}>
          <div className={styles.authBannerTop}>
            <MdErrorOutline />
            <span className={styles.authBannerTitle}>{formError}</span>
          </div>
        </div>
      ) : null}
    </>
  );
}
